"use client";

import { Typography } from "@/components/ui/typography";
import { getQuoteSupportData } from "./constants";
import { memo } from "react";
import { SupportCardsCarousel } from "@/components/screen/global-components/support";

const GetQuoteSupport = ({}: React.ComponentProps<"section">) => {
  const { title, cards } = getQuoteSupportData;

  return (
    <section className="section overflow-hidden bg-white md:border-t md:border-t-neutral-100">
      <div className="container !max-w-[1232] mx-auto py-12">
        <div className="flex flex-col gap-4 md:justify-center md:gap-2 md:w-full md:max-w-[784] md:mx-auto md:text-center font-semibold">
          <Typography variant="headingFixed4">
            <h2>{title}</h2>
          </Typography>
        </div>
        <SupportCardsCarousel
          cards={cards}
          className="mt-6 md:mt-8 lg:!grid-cols-4"
          imageCardRatioBoost
          responsive={false}
        />
      </div>
    </section>
  );
};

export default memo(GetQuoteSupport);
